var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVdlawgroupLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 54,
    viewBox: "0 0 98 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4184_24452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1706 29.9854L39.2874 35.0887L30.7013 39.5219L24.8281 42.5542V32.4493L29.599 29.9854H49.1706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8283 32.4496V42.5544L18.9565 39.5221H18.955L10.3676 35.0875L0.484375 29.9856V9.90039L7.06755 23.2778L10.3676 29.9856V24.9826L24.8283 32.4496Z",
    fill: "#F4E100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1732 0.000976562V4.9516L39.2885 24.9831V0.000976562H49.1732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0561 0.000976562V24.9831L49.1714 4.9516V0.000976562H59.0561Z",
    fill: "#F4E100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0561 24.9826V29.9855H49.1714V4.95117L59.0561 24.9826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5144 9.32262V30.5642C97.5144 35.7127 93.3478 39.8858 88.2076 39.8858H73.0338V29.986H87.6303V9.90079H59.0558V0.000976562H88.2076C93.3478 0.000976562 97.5144 4.17408 97.5144 9.32262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0341 29.9854V39.8852H67.1749L59.0561 35.4209L49.1714 29.9854H73.0341Z",
    fill: "#F4E100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1749 39.8852H49.1714V29.9854L59.0561 35.4209L67.1749 39.8852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1737 4.95117V29.9855H29.6006L39.289 24.9826L49.1737 4.95117Z",
    fill: "#F4E100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3676 0.000976562V29.986L7.06754 23.2782L0.484375 9.9008V0.000976562H10.3676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7945 53.158H36.5234L37.6582 49.2182L38.7945 45.2783L39.9293 49.2182L41.0642 53.158H38.7945Z",
    fill: "#F4E100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53953 51.3401H10.8016V53.158H3.53953C1.92621 53.158 1.11884 52.3495 1.11884 50.7336V45.2783H2.93401V50.7336C2.93401 51.1379 3.13585 51.3401 3.53953 51.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6984 47.7027V53.158H11.8832V47.7027C11.8832 46.0869 12.6906 45.2783 14.3039 45.2783H19.1453C20.7587 45.2783 21.566 46.0869 21.566 47.7027V53.158H19.7508V50.7336H14.9095V48.9157H19.7508V47.7042C19.7508 47.2999 19.549 47.0977 19.1453 47.0977H14.3039C13.9003 47.0977 13.6984 47.2999 13.6984 47.7042V47.7027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2061 50.7336V45.2783H25.0212V50.7336C25.0212 51.1379 25.2231 51.3401 25.6268 51.3401H27.4419C27.8456 51.3401 28.0474 51.1379 28.0474 50.7336V45.2783H29.8626V50.7336C29.8626 51.1379 30.0645 51.3401 30.4682 51.3401H32.2833C32.687 51.3401 32.8889 51.1379 32.8889 50.7336V45.2783H34.704V50.7336C34.704 52.3495 33.8966 53.158 32.2833 53.158H30.4682C29.8428 53.158 29.339 53.0365 28.955 52.7948C28.5711 53.0379 28.0672 53.158 27.4419 53.158H25.6268C24.0135 53.158 23.2061 52.3495 23.2061 50.7336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 45.2783H52.4041V47.0963H45.142C44.7383 47.0963 44.5365 47.2985 44.5365 47.7027V50.7336C44.5365 51.1379 44.7383 51.3401 45.142 51.3401H50.5889V50.1286H45.7475V48.3107H52.4041V53.1595H45.142C43.5286 53.1595 42.7213 52.3509 42.7213 50.7351V47.7042C42.7213 46.0884 43.5286 45.2798 45.142 45.2798V45.2783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1081 47.0977V53.158H54.293V45.2783H61.5551C63.1684 45.2783 63.9758 46.0869 63.9758 47.7027C63.9758 49.3186 63.1684 50.1272 61.5551 50.1272H61.0949L64.1212 53.158H61.5551L56.7137 48.3092H61.5551C61.9588 48.3092 62.1606 48.1071 62.1606 47.7027C62.1606 47.2985 61.9588 47.0963 61.5551 47.0963H56.1081V47.0977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4618 45.2783H72.3032C73.9166 45.2783 74.724 46.0869 74.724 47.7027V50.7336C74.724 52.3495 73.9166 53.158 72.3032 53.158H67.4618C65.8485 53.158 65.0411 52.3495 65.0411 50.7336V47.7027C65.0411 46.0869 65.8485 45.2783 67.4618 45.2783ZM72.3032 47.0963H67.4618C67.0582 47.0963 66.8563 47.2985 66.8563 47.7027V50.7336C66.8563 51.1379 67.0582 51.3401 67.4618 51.3401H72.3032C72.7069 51.3401 72.9087 51.1379 72.9087 50.7336V47.7027C72.9087 47.2985 72.7069 47.0963 72.3032 47.0963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0855 50.7336V45.2783H85.9006V50.7336C85.9006 52.3495 85.0934 53.158 83.4797 53.158H78.6385C77.0252 53.158 76.2178 52.3495 76.2178 50.7336V45.2783H78.0329V50.7336C78.0329 51.1379 78.2348 51.3401 78.6385 51.3401H83.4797C83.8833 51.3401 84.0855 51.1379 84.0855 50.7336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6028 47.0977V53.158H87.7878V45.2783H95.0504C96.6633 45.2783 97.4705 46.0869 97.4705 47.7027C97.4705 49.3186 96.6633 50.1272 95.0504 50.1272H90.8145V48.3092H95.0504C95.4541 48.3092 95.6555 48.1071 95.6555 47.7027C95.6555 47.2985 95.4541 47.0963 95.0504 47.0963H89.6028V47.0977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4184_24452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.0312,
    height: 54,
    fill: "white",
    transform: "translate(0.484375 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdlawgroupLogo2);
export default __webpack_public_path__ + "static/media/vdlawgroupLogo2.ee4eb055950199d96414880fd5f588ee.svg";
export { ForwardRef as ReactComponent };